import React, { FC } from 'react'
import PCWBasketCard from 'Components/Environments/PCW/PCWBasketCard/PCWBasketCard'
import { useSelector } from 'react-redux'
import { selectPCWSchema } from 'redux/reducers/dataStore/dataStore.selectors'
import { getPCWProductInBasket } from 'redux/reducers/logicStore/logicStore.selectors'
import {
  BasketPageStyle,
  ContentWrapperStandAlone,
} from '../../../Shared/BasketPage/BasketPageStyle'

/**
 * StandaloneBasket shows only the basket page with selected products (cards and addons) without having the whole journey.
 * It is used in EFS to remind the users the choises they made afte running the experiment.
 */

export const StandaloneBasket: FC = () => {
  const basketItems = useSelector(getPCWProductInBasket)
  const pcwSchema = useSelector(selectPCWSchema)

  return (
    <BasketPageStyle>
      <ContentWrapperStandAlone>
        <PCWBasketCard pcwCardproperties={basketItems} schema={pcwSchema} />
      </ContentWrapperStandAlone>
    </BasketPageStyle>
  )
}
